<div class="bp-asset-list">
  <div class="bp-asset-list-search-bar">
    <bp-search-bar
      (searchValueChange)="onSearchValueChange($event)"
    [placeholder]="'search_bar_placeholder_buy' | translate"></bp-search-bar>
  </div>

  <div class="bp-asset-list-filter">
    <bp-toggle-group
      [options]="filters$ | async"
      [selected]="selectedFilter"
      (onValueChange)="onFilterChange($event)">
    </bp-toggle-group>
  </div>

  <!--	<div class="bp-asset-list-timeframe">-->
  <!--		<bp-toggle-group [options]="timeframes" [selected]="timeframes[0]" (onValueChange)="onTimeframeChange($event)"-->
<!--			[isSmall]="true"></bp-toggle-group>-->
<!--	</div>-->

<!-- Risk Summary needed for UK -->
<app-uk-risk-summary [classes]="'mb-40'"></app-uk-risk-summary>

@if (pillsThatNeedRealSecuritiesBanner | include_pipe: filterValue) {
  <div class="security_banner_margin">
    <real-securities-banner
      [title]="'inline_banner_real_securities_savings_plans_title' | translate"
      [subtitle]="'inline_banner_real_securities_coming_soon_web' | translate"
      />
  </div>
}

@if (searchValue === '' && filterValue === '') {
  @if ((userHasNoBciSavingsPlans$ | async) === true) {
    <banner-card
      [translationKeyPrefix]="'bci_banner'"
      [iconSrc]="'/assets/images/bci_banner_calendar.svg'"
      (actionClicked)="bannerClick()">
    </banner-card>
  }
  @if (mostPopularList$ | async; as mostPopularList) {
    @if (mostPopularList.length > 0) {
      <div class="bp-asset-list-most-popular">
        <div class="most-popular-title">
          {{ "most_popular" | translate }}
        </div>
        <most-popular-tradables [mostPopularList]="mostPopularList" (onTradableClick)="onClick($event)">
        </most-popular-tradables>
      </div>
    }
  }
}

@if (searchValue === '') {
  <div class="all-assets-title">
    {{ headlines[filterValue] | translate }}
  </div>
}

@if (tradables$ | async; as tradables) {
  <div class="bp-asset-list-table">
    <bp-table
      [items]="tradables"
      [(scrollToTop)]="scrollToTop"
      (itemClicked)="onClick($event)"
      (scrolledToBottom)="onScrolledToBottom()"
      matSort
      (matSortChange)="onSortChange($event)">
      <ng-template [bpTableHeader]="tradables">
        <div bpTableHeaderCell mat-sort-header="name">
          {{ "all_charts_price_column_label_name" | translate }}
        </div>
        <div bpTableHeaderCell mat-sort-header="change">
          {{ "all_charts_price_column_label_change" | translate }}
          <span
            class="bp-table-disclaimer bpi__icon-info"
          [bp-tooltip]="'tradable_list_selection_change_tooltip_info' | translate"></span>
        </div>
        <div bpTableHeaderCell mat-sort-header="price">
          {{ "all_charts_price_column_label_price" | translate }}
        </div>
      </ng-template>
      <ng-template [bpTableRow]="tradables" let-tradable>
        <div bpTableCell>
          <img
            bpTableCellLogo
            [src]="tradable.getLogo()"
            (error)="img.src = tradable.getDefaultLogo()"
            alt="{{ 'logo_alt_text' | translate }}"
            #img />
          <div class="flex flex-col text-color">
            <div bpTableCellLine bpTableOverflowEllipsis>
              {{ tradable.getName() }}
            </div>
            <div bpTableCellLine>
              {{ tradable.getSymbol(false, true) }}
            </div>
          </div>
        </div>
        <div bpTableCell>
          <bp-value-change [value]="getChangePercent(tradable)">
            {{ getChangePercent(tradable) | fiat_precision | add_number_prefix | percent_symbol }}
          </bp-value-change>
        </div>
        <div bpTableCell class="bp-asset-list-price text-color">
          @if (!isIndex(tradable)) {
            {{
            tradable.getPrice()
            | euro_to_user_fiat
            | fiat_precision_symbol
            : {
            id: defaultFiat.getId(),
            currencies: [defaultFiat, tradable],
            symbol: true
          }
          }}
        } @else {
          {{
          tradable.getPrice()
          | fiat_precision_symbol
          : {
          id: defaultFiat.getId(),
          currencies: [defaultFiat, tradable],
          symbol: true,
          removeCurrency: true
        }
        }}
      }
    </div>
  </ng-template>
  <ng-template bpTableMessage>
    @if (isLoading$ | async) {
      <loading-spinner></loading-spinner>
    }
    @if (hasError$ | async) {
      <tradable-list-empty [filteredList$]="tradables$" (refetchData)="refetchList()">
      </tradable-list-empty>
    }
  </ng-template>
</bp-table>
</div>
}
</div>
